module.exports = __webpack_public_path__ + "static/year_month_columns-381456fe99e306c9e5e84562336f5a3f.png";